import { GeoJsonType } from "@churchofjesuschrist/maps-models";
const Convertible = Object.freeze({
  POSITION: "Position",
  BOUNDING_BOX: "BoundingBox",
  GEOMETRY: "Geometry",
  GEOJSON: "GeoJson",
  ...GeoJsonType,
  POSITION_BOX: "PositionBox",
  SIZE: "Size",
  INTERSECTION: "Intersection",
  INTERSECTION_CONNECTION: "IntersectionConnection",
  CLUSTER: "Cluster",
  LOCATION: "Location",
  ROUTE: "Route",
  ROUTE_LEG: "RouteLeg",
  ROUTE_STEP: "RouteStep"
});
export default Convertible;